var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReceiptsAllIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_204_2907)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.46972 5C2.65844 5 2 5.65844 2 6.46972C2 7.28101 2.65844 7.93945 3.46972 7.93945C4.28101 7.93945 4.93945 7.28101 4.93945 6.46972C4.93945 5.65844 4.28101 5 3.46972 5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.46972 10.3262C2.65844 10.3262 2 10.9847 2 11.796C2 12.6072 2.65844 13.2657 3.46972 13.2657C4.28101 13.2657 4.93945 12.6072 4.93945 11.796C4.93945 10.9847 4.28101 10.3262 3.46972 10.3262Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.46972 15.6642C2.65844 15.6642 2 16.3226 2 17.1339C2 17.9452 2.65844 18.6036 3.46972 18.6036C4.28101 18.6036 4.93945 17.9452 4.93945 17.1339C4.93945 16.3226 4.28101 15.6642 3.46972 15.6642Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.742 5.29385H7.92597C7.24402 5.29385 6.69141 5.82295 6.69141 6.46963C6.69141 7.11631 7.24402 7.64541 7.92597 7.64541H20.742C21.4239 7.64541 21.9765 7.11631 21.9765 6.46963C21.9765 5.82295 21.4239 5.29385 20.742 5.29385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.742 10.6202H7.92597C7.24402 10.6202 6.69141 11.1493 6.69141 11.796C6.69141 12.4427 7.24402 12.9718 7.92597 12.9718H20.742C21.4239 12.9718 21.9765 12.4427 21.9765 11.796C21.9765 11.1493 21.4239 10.6202 20.742 10.6202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7772 15.958H7.91413C7.23218 15.958 6.67957 16.4871 6.67957 17.1338C6.67957 17.7805 7.23218 18.3096 7.91413 18.3096H20.7654C21.4473 18.3096 22 17.7805 22 17.1338C22 16.4871 21.4473 15.958 20.7654 15.958H20.7772Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_204_2907"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 13.6038,
    fill: "white",
    transform: "translate(2 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiptsAllIcon);
export default __webpack_public_path__ + "static/media/receipts-all-icon.9295d68e0c97958fc05f0f28c4550101.svg";
export { ForwardRef as ReactComponent };